import Button from './Button'
import Link from 'next/link'

const social = [
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/fcatalanapadel/',
    icon: 'instagram-white'
  },
  {
    name: 'Facebook',
    href: 'https://www.facebook.com/FederacioCatalanaPadel',
    icon: 'facebook-white'
  },
  {
    name: 'YouTube',
    href: 'https://www.youtube.com/@fcatalanapadel ',
    icon: 'youtube-white'
  },
  {
    name: 'Twitter',
    href: 'https://twitter.com/fcatalanapadel',
    icon: 'twitter-white'
  },
  {
    name: 'TikTok',
    href: 'https://www.tiktok.com/@fcatalanapadel',
    icon: 'tiktok-white'
  }
]

const Social = () => {
  return (
    <>
      <p className="mt-4 lg:mt-6 font-alliance-light text-white text-[13px] lg:text-[14px]">
        Segueix-nos a
      </p>
      <div className="flex space-x-4 mt-6">
        {social?.map((item, idx) => (
          <Link key={idx} href={item?.href ?? '#'}>
            <span className="sr-only">{item.name}</span>
            <img src={`/assets/icons/${item?.icon}.svg`} aria-hidden="true" />
          </Link>
        ))}
      </div>
    </>
  )
}

export default Social
